import Typography from '@mui/material/Typography';

export default function Subtitle({children,label,...props}) {
    return (<Typography variant="subtitle1" sx={{textAlign: "center", marginY: 1}} {...props}>{children}</Typography>);
}

